var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.4C5 3.76348 5.25286 3.15303 5.70294 2.70294C6.15303 2.25286 6.76348 2 7.4 2H17C17.6365 2 18.247 2.25286 18.6971 2.70294C19.1471 3.15303 19.4 3.76348 19.4 4.4V17.6C19.4 17.9183 19.2736 18.2235 19.0485 18.4485C18.8235 18.6736 18.5183 18.8 18.2 18.8H6.2C6.2 19.1183 6.32643 19.4235 6.55147 19.6485C6.77652 19.8736 7.08174 20 7.4 20H18.8C18.9591 20 19.1117 20.0632 19.2243 20.1757C19.3368 20.2883 19.4 20.4409 19.4 20.6C19.4 20.7591 19.3368 20.9117 19.2243 21.0243C19.1117 21.1368 18.9591 21.2 18.8 21.2H7.4C6.76348 21.2 6.15303 20.9471 5.70294 20.4971C5.25286 20.047 5 19.4365 5 18.8V4.4ZM8.3 4.4C8.06131 4.4 7.83239 4.49482 7.6636 4.6636C7.49482 4.83239 7.4 5.06131 7.4 5.3V5.9C7.4 6.3968 7.8032 6.8 8.3 6.8H16.1C16.3387 6.8 16.5676 6.70518 16.7364 6.5364C16.9052 6.36761 17 6.1387 17 5.9V5.3C17 5.06131 16.9052 4.83239 16.7364 4.6636C16.5676 4.49482 16.3387 4.4 16.1 4.4H8.3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookicon);
export default __webpack_public_path__ + "static/media/book.icon.9c39318c2b64834b261145895455dee3.svg";
export { ForwardRef as ReactComponent };